module.exports = __webpack_public_path__ + "img/vista-lite-se-womens.095d2b90.png";